// segments/index.js — routes for segment library + editor
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import SegmentsList from './segmentsList.js';
import SegmentEditor from './segmentEditor.js';

const Segments = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={SegmentsList} />
    <Route exact path={`${match.url}/new`} component={SegmentEditor} />
    <Route exact path={`${match.url}/:id/edit`} component={SegmentEditor} />
    <Redirect to={`${match.url}`} />
  </Switch>
);

export default Segments;
